import { render, staticRenderFns } from "./PalletBoxScan.vue?vue&type=template&id=5e2a7f2a&scoped=true"
import script from "./PalletBoxScan.vue?vue&type=script&lang=js"
export * from "./PalletBoxScan.vue?vue&type=script&lang=js"
import style0 from "./PalletBoxScan.vue?vue&type=style&index=0&id=5e2a7f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2a7f2a",
  null
  
)

export default component.exports